import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BillingService } from '../../../services/billing.service';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material';

@Component({
    selector: 'dialog-view-Parent-Pnr',
    templateUrl: 'dialog.viewParentPnr.html'
})
export class ViewParentPnrDialog implements OnInit, OnDestroy {
    allSub: Subscription[] = [];
    errorMessage: string = '';
    parentPnr: string = '';
    loading: boolean = false;

    constructor(public dialogRef: MatDialogRef<ViewParentPnrDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private billingService: BillingService,
        public snackBar: MatSnackBar) { }

    ngOnInit() {
        this.parentPnr = this.data.selectedParentPnr
        // let export_init_sub = this.billingService.getParentPnr(this.data.selectedPnr)
        //     .subscribe(
        //         (data) => {
        //             this.parentPnr = data.Pnr;
        //             this.loading = false;
        //         },
        //         (error) => {
        //             this.loading = false;
        //             this.errorMessage = <any>error;
        //             this.openSnackBar(this.errorMessage, '');
        //         });

        // //Adds into array for each subscribe
        // this.allSub.push(export_init_sub);
    }

    closeDialog(): void {
        this.dialogRef.close('Close');
    }

    ngOnDestroy() {
        for (let sub of this.allSub) {
            sub.unsubscribe();
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }
}